export default __webpack_public_path__ + "static/media/logoHorizontalBlanco.8fae0954.png";